import React from 'react';

type Props = {
	data:any,
}

export default class ResponsiveImage extends React.Component<Props & React.ImgHTMLAttributes<HTMLImageElement>>
{
	render()
	{
		let className:any = this.props.className;
		if(!className) className = '';
		className = className.toLowerCase().split(' ');
		let a = [];
		let desktopClassName = [].concat(className);
		let mobileClassName = [].concat(className);
		if(this.props.data.mobile)
		{
			desktopClassName.push('hide-small');
			mobileClassName.push('show-small');
		}
		return (
			<React.Fragment>
			<img {...this.props} {...this.props.data} className={desktopClassName.join(' ')}></img>
			{
				(this.props?.data?.mobile)?
				(
					<img {...this.props.data.mobile} className={mobileClassName.join(' ')}></img>
				):null
			}
			</React.Fragment>
		)
	}
}